import React, { useState, useEffect, useCallback } from "react";
import { PH3Text, FlexContainer, Img, Input, LabelText, SpanText, Hr, InputWrapper, Text } from "../../design";
import { Controller } from "react-hook-form";
import Select from "react-select";
import NumberFormat from "react-number-format";
import { ErrorMessage } from "@hookform/error-message";
import debounce from "lodash.debounce";
import CvvIcon from "../../assets/imgs/cvv.svg";
import Luhn from "luhn";
import CreditCardType from "credit-card-type"
import { BrandLogo } from "../../helper";
import { CARD_NUMBER_LENGTH, ACCOUNT_MDR, VALID_YEAR_MONTH, COUNTRIES_LIST } from "../../appconstants";
import { Row, Col, Container } from 'react-awesome-styled-grid';

const postalCodes = require('postal-codes-js');

type Props = {
  control: any,
  errors: any,
  charges: boolean,
  getPaymentCharges: Function,
  getPostalCodeChange: Function,
  callBackStatelist: Function,
  userType: String,
  alpha2: String,
  payments: Object,
  setValue: any,
  showWhatsAppNotify: Boolean,
  showPromoter: Boolean,
  isZipCodeRequired: boolean,
  isBillingAdressRequired: Boolean,
  billStatesList: Array,
  billStatesList2: Array,
  billStatesList2: Array,
  defaultCountry: Any,
  defaultCountry2: Any,
  callBackCountryCode: Function,
  getCardNum: Function,
  clearZipCode: Boolean
}

const Card = (props: Props) => {

  const DEFAULT_CARD_NUMBER_MASK = "#### #### #### #### ###";
  const { control, setValue, errors, showWhatsAppNotify, showPromoter, callBackCountryCode, defaultCountry, defaultCountry2, callBackStatelist, callBackStatelistShip, billStatesList, billStatesList2, charges, getPaymentCharges, getPostalCodeChange, getPostalCodeChange2, userType, payments, watch, isZipCodeRequired, isBillingAdressRequired, isShippingAddressRequired, clearErrors, getCardNum, clearZipCode } = props;
  const [cardBrand, setCardBrand] = useState(null);
  const [cardNumberLengthMask, setCardNumberLengthMask] = useState(DEFAULT_CARD_NUMBER_MASK);
  const postalCode = 'Zip Code';
  const zipCode = 'Zip Code';
  const pincodeLabel = 'Zip Code';
  const [checked, setChecked] = useState(false);
  const [checkedShipping, setShippingChecked] = useState(false);
  const [promoterCheck, setPromoterCheck] = useState(true);
  const [countryNameCode2, setCountryNameCode2] = useState();

  //One School At A Time, Inc

  const accntGid = [
    'account-c0adbb4137dc4d6c9a9df98cb29bf401',
  ];

  useEffect(() => {
    setValue('notify', checked);
  }, [checked]);

  useEffect(() => {
    setValue('promoter', promoterCheck);
  }, [promoterCheck]);

  const isExpiryValidate = (data: string) => {
    const cardExpiry = data && data.split(" / ");
    const today = new Date(); const expireDay = new Date();
    const findYear = parseInt(cardExpiry[1]);
    const charYear = findYear.toString();
    const count = charYear.length;
    let year;
    if (count === 2) {
      year = parseInt(cardExpiry[1]) + VALID_YEAR_MONTH.ADDINGYEARS;
    } else {
      year = parseInt(cardExpiry[1]);
    }
    expireDay.setFullYear(parseInt(year), parseInt(cardExpiry[0]), 1);
    if (isEmpty(cardExpiry[1]) || isEmpty(cardExpiry[0]) ||
      parseInt(cardExpiry[0]) > VALID_YEAR_MONTH.TOTALMONTHS || parseInt(year) > VALID_YEAR_MONTH.MAXYEAR || expireDay < today) {
      return "Please enter a valid card expiration date";
    }
  };

  const isZipcodeValidate = (data: string) => {
    const cuntryCode = watch().country;
    if (postalCodes.validate(cuntryCode, data) !== true) {
      return postalCodes.validate(cuntryCode, data)
    }
  };

  const isZipcodeValidate1 = (data: string) => {
    const cuntryCode = watch().country;
    if (postalCodes.validate(cuntryCode, data) !== true) {
      return postalCodes.validate(cuntryCode, data)
    }
  };

  const isZipcodeValidateShip = (data: string) => {
    const cuntryCode = accntGid.includes(payments?.account?.gid) ? "US" : watch().shipcountry;
    if (postalCodes.validate(cuntryCode, data) !== true) {
      return postalCodes.validate(cuntryCode, data)
    }
  };

  const isEmpty = data => {
    return data && /^\s*$/.test(data);
  };

  const isCardValidate = (data: string) => {
    let number = data && data.replace(/\s+/g, '');
    const cardDetails = CreditCardType(number);
    let cardNumberLengths = [11, 12, 13, 14, 15, 16, 17, 18, 19];
    if (cardDetails.length > 0) {
      const card = cardDetails && cardDetails[0];
      cardNumberLengths = card && card.lengths;
    }
    if (!number || !cardNumberLengths.includes(number.length) || !Luhn.validate(number)) {
      return "Invalid card number";
    }
  };

  const validCard = (data: string) => {
    let number = data && data.replace(/\s+/g, '');
    const cardDetails = CreditCardType(number);
    let cardNumberLengths = [11, 12, 13, 14, 15, 16, 17, 18, 19];
    if (cardDetails.length > 0 && cardNumberLengths.includes(number.length)) {
      const card = cardDetails && cardDetails[0];
      cardNumberLengths = card && card.lengths;
      return true;
    }
    if (!number || !cardNumberLengths.includes(number.length) || !Luhn.validate(number)) {
      return false;
    }
  };

  const setCardBrandIcon = (data: string) => {
    const { value } = data;
    const cardDetails = CreditCardType(value);
    let cardBrand = null;
    if (cardDetails.length > 0) {
      const card = cardDetails && cardDetails[0];
      const { type } = card;
      cardBrand = value ? type : null;
    }
    setCardNumberLengthMask(DEFAULT_CARD_NUMBER_MASK);
    if (cardBrand && CARD_NUMBER_LENGTH[cardBrand]) {
      setCardNumberLengthMask(maskStrGenarator(CARD_NUMBER_LENGTH[cardBrand]));
    }
    setCardBrand(cardBrand);
  };

  const maskStrGenarator = (length: number) => {
    let output = "";
    for (let i = 0; i < length; i++) {
      if (i > 0 && i % 4 === 0) {
        output += " "
      }
      output += "#";
    }
    return output;
  };

  const debounceGetPaymentCharges = useCallback(
    debounce((searchVal, payments) => {
      getPaymentCharges(searchVal, payments);
    }, 2000),
    []
  );

  const getCharges = (e) => {
    const { value } = e;
    if (validCard(value && value.replace(/ /g, "")) && charges && userType !== ACCOUNT_MDR.MERCHANT) {
      debounceGetPaymentCharges(value, payments);
    }
    if (validCard(value && value.replace(/ /g, "")) && getCardNum) {
      getCardNum(value.replace(/ /g, ""));
    }
  };

  const debounceGetPostalCodeChange = useCallback(
    debounce((searchVal) => {
      getPostalCodeChange(searchVal);
    }, 500),
    []
  );

  const debounceGetPostalCodeChange2 = useCallback(
    debounce((searchVal) => {
      getPostalCodeChange2(searchVal);
    }, 500),
    []
  );

  const getCountryCode = (value) => {
    debounceGetPostalCodeChange(value);
  };

  const getCountryCode2 = (value) => {
    debounceGetPostalCodeChange2(value);
  };

  const getStatelist = (value) => {
    callBackStatelist(value);
  }

  const getStatelistShip = (value) => {
    callBackStatelistShip(value);
  }

  const customStyles = {
    container: base => ({
      ...base,
      width: '100%',
      height: '41px',
      marginTop: '8px',
      marginBottom: '8px',
      borderRadius: '10px',
    }),
    control: base => ({
      ...base,
      height: '41px',
      minHeight: 33,
      border: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
    }),
    dropdownIndicator: base => ({
      ...base,
      height: 33,
      minHeight: 33,
    }),
  };

  const handleShipAddressChangeStateShip = (selectedOption, value1, value) => {
    setValue(value, selectedOption);
  };

  const handleShipAddressChangeState = (selectedOption, value1, value) => {
    if (checkedShipping && value1 === "billstate") {
      setValue(value, selectedOption?.value);
      setValue(value1, selectedOption?.value);
    } else if (checkedShipping && value1 === "country") {
      setValue(value1, selectedOption?.value);
      setValue(value, selectedOption?.value);
      setValue("billstate", "");
      setValue("shipstate", "");
    } else {
      setValue(value1, selectedOption?.value);
    };
  };


  const setBillingToShipping = (target) => {
    setShippingChecked(target.checked);
    const { billstate, country, billaddress, billaddress1, billcity, zipCode } = watch();
    setValue("shipstate", billstate);
    setValue("shipcountry", country);
    setValue("shipaddress", billaddress);
    setValue("shipaddress1", billaddress1);
    setValue("shipcity", billcity);
    setValue("shipzipCode", zipCode);
  }

  const handleShipAddressChange = (e, caseType, shipValue) => {
    if (checkedShipping) {
      setValue(caseType, e);
      setValue(shipValue, e);
    } else {
      setValue(caseType, e);
    }
  };

  const stateOptions = billStatesList?.map((item) => {
    return { label: item?.name, value: item?.isoCode }
  });

  const shipStateOptions = billStatesList2?.map((item) => {
    return { label: item?.name, value: item?.isoCode }
  });

  const countryOptions = COUNTRIES_LIST?.map((item) => {
    return { label: item?.name, value: item?.code }
  });

  const customInputStyle = {
    background: 'white',
    // color: 'black',
    borderColor: '#CCCCCC',
    width: '100%',
    height: '41px',
    paddingLeft: '15px',
  }

  const customLabelStyle = {
    color: 'black'
  };

  const customContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '#CCCCCC',
    borderRadius: '5px',
    marginTop: '8px',
    marginBottom: '8px',
  }

  const customRowFlexContainerProps = {
    xs: '100%',
    md: '100%',
    gap: '5%',
  };

  const customColFlexContainerProps = {
    xs: '100%',
    flexDirection: 'col',
  };

  return (
    <>
      <FlexContainer>
        <FlexContainer {...customRowFlexContainerProps}>
          <PH3Text className="my-3 mx-0 p-0" fontWeight="bold">CARD DETAILS</PH3Text>
        </FlexContainer>
        <FlexContainer {...customRowFlexContainerProps}>
          <FlexContainer {...customColFlexContainerProps} md="45%">
            <LabelText  style={{...customLabelStyle}}>
              Card Number <span style={{ color: 'red' }}>*</span>
            </LabelText>
            <Container
              style={{...customContainerStyle, paddingRight: '0px', paddingLeft: '0px'}}
            >
              <Controller
                defaultValue={''}
                border="0px !important"
                marginBottom="0px"
                marginTop="0px"
                marginLeft="5px"
                borderDown="none"
                control={control}
                name="card"
                color={errors.card ? "red" : "inherit"}
                rules={{
                  required: "Card number is required",
                  validate: isCardValidate
                }}
                as={<NumberFormat style={{...customInputStyle}}
                  onValueChange={values => {
                    setCardBrandIcon(values);
                    getCharges(values);
                  }}
                  placeholder="Enter your card number"
                />}
                customInput={Input}
                format={cardNumberLengthMask}
                mask=""
              />
              <section style={{ paddingRight: '15px'}}>
                {BrandLogo(cardBrand)}
              </section>
            </Container>
            <ErrorMessage
              errors={errors}
              name="card"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
          </FlexContainer>
          <FlexContainer {...customColFlexContainerProps} md="30%">
            <LabelText  style={{...customLabelStyle}}>
              Expiry <span style={{ color: 'red' }}>*</span>
            </LabelText>
            <Controller
              defaultValue={''}
              {...props}
              control={control}
              name="expiry"
              color={errors.expiry ? "red" : "inherit"}
              rules={{
                required: "Expiry is required",
                validate: isExpiryValidate
              }}
              as={<NumberFormat
                style={{...customInputStyle}}
                placeholder="MM / YYYY"
              />}
              customInput={Input}
              format="## / ####"
            />
            <ErrorMessage
              errors={errors}
              name="expiry"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
          </FlexContainer>
          <FlexContainer {...customColFlexContainerProps} md="15%">
            <LabelText style={{...customLabelStyle}}>
              CVC <span style={{ color: 'red' }}>*</span>
            </LabelText>
            <InputWrapper style={{...customContainerStyle, width: '100%'}}>
              <Controller
                defaultValue={''}
                border="0px !important"
                marginBottom="0px"
                marginTop="0px"
                marginLeft="5px"
                width='0px'
                control={control}
                name="cvv"
                color={errors.cvv ? "red" : "inherit"}
                rules={{
                  required: 'CVC is required',
                  pattern: {
                    value: /\d{3,4}/,
                    message: 'Invalid CVC number',
                  },
                }}
                as={<NumberFormat
                  style={{...customInputStyle}}
                  placeholder="CVC"
                />}
                customInput={Input}
                format="####"
                mask=""
                type="password"
              />
              <Img verticalAlign='middle' src={CvvIcon} style={{ paddingRight: '15px' }}/>
            </InputWrapper>
            <ErrorMessage
              errors={errors}
              name="cvv"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
          </FlexContainer>
        </FlexContainer>
        <FlexContainer {...customRowFlexContainerProps}>
          <FlexContainer {...customColFlexContainerProps} md="45%">
            <LabelText style={{...customLabelStyle}}>
              Cardholder Name <span style={{ color: 'red' }}>*</span>
            </LabelText>
            <Controller
              defaultValue={''}
              marginBottom="0px"
              control={control}
              name="name"
              placeholder="Enter cardholder name"
              color={errors.name ? "red" : "inherit"}
              rules={{
                required: 'Cardholder name is required',
                pattern: {
                  value: /^[a-zA-Z ]*$/,
                  message: 'Name can only contain alpha characters and spaces.',
                }
              }}
              as={<Input
                style={{...customInputStyle}}
              />}
            />
            <ErrorMessage
              errors={errors}
              name="name"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
      {
        isBillingAdressRequired ? (
          <>
            <Hr />
            {
              <>
                {defaultCountry && (
                  <div>
                    <FlexContainer>
                      <FlexContainer {...customRowFlexContainerProps}>
                        <PH3Text className="my-3 mx-0 p-0" fontWeight="bold">BILLING DETAILS</PH3Text>
                      </FlexContainer>
                      <FlexContainer {...customRowFlexContainerProps}>
                        <FlexContainer {...customColFlexContainerProps} md="100%">
                          <LabelText style={{...customLabelStyle}}>
                            Address Line 1 <span style={{ color: 'red' }}>*</span>
                          </LabelText>
                          <Controller
                            color={errors.billaddress ? "red" : "inherit"}
                            marginBottom="0px"
                            control={control}
                            name="billaddress"
                            placeholder="Address"
                            rules={{
                              required: 'Address is required',
                            }}
                            render={({ field }) => (
                              <Input
                                {...field}
                                defaultValue={watch()?.billaddress || ""}
                                placeholder="Address"
                                onChange={(e) => {
                                  clearErrors("billaddress");
                                  handleShipAddressChange(e.target.value, "billaddress", "shipaddress"); // Your custom logic
                                }}
                                style={{...customInputStyle}}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="billaddress"
                            render={({ message }) => (
                              <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                            )}
                          />
                        </FlexContainer>
                      </FlexContainer>
                      <FlexContainer {...customRowFlexContainerProps}>
                        <FlexContainer {...customColFlexContainerProps} md="63.3%">
                          <LabelText style={{...customLabelStyle}}>
                            Address Line 2
                          </LabelText>
                          <Controller
                            defaultValue={""}
                            color={errors.billaddress1 ? "red" : "inherit"}
                            marginBottom="0px"
                            control={control}
                            name="billaddress1"
                            placeholder="Address2"
                            render={({ field }) => (
                              <Input
                                {...field}
                                defaultValue={""}
                                placeholder="Address"
                                onChange={(e) => {
                                  clearErrors("billaddress1");
                                  handleShipAddressChange(e.target.value, 'billaddress1', 'shipaddress1'); // Your custom logic
                                }}
                                style={{...customInputStyle}}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="billaddress1"
                            render={({ message }) => (
                              <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                            )}
                          />
                        </FlexContainer>
                        <FlexContainer {...customColFlexContainerProps} md="31.6%">
                          <LabelText style={{...customLabelStyle}}>
                            City <span style={{ color: 'red' }}>*</span>
                          </LabelText>
                          <Controller
                            defaultValue={""}
                            color={errors.billcity ? "red" : "inherit"}
                            marginBottom="0px"
                            control={control}
                            name="billcity"
                            placeholder="City"
                            rules={{
                              required: 'City is required',
                            }}
                            render={({ field }) => (
                              <Input
                                {...field}
                                defaultValue={watch()?.billcity || ""}
                                placeholder="City"
                                onChange={(e) => {
                                  clearErrors("billcity");
                                  handleShipAddressChange(e.target.value, 'billcity', 'shipcity'); // Your custom logic
                                }}
                                style={{...customInputStyle}}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="billcity"
                            render={({ message }) => (
                              <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                            )}
                          />
                        </FlexContainer>
                      </FlexContainer>
                      <FlexContainer {...customRowFlexContainerProps}>
                        <FlexContainer {...customColFlexContainerProps} md="30%">
                          <LabelText style={{...customLabelStyle}}>
                            State <span style={{ color: 'red' }}>*</span>
                          </LabelText>
                          <Controller
                            control={control}
                            name="billstate"
                            rules={{ required: "State is required" }}
                            render={({ field }) => {
                              return (
                                <Select
                                  {...field}
                                  // theme={(theme) => ({
                                  //   ...theme,
                                  //   borderRadius: "4px",
                                  //   boxShadow: 0,
                                  // })}
                                  menuPlacement="auto"
                                  styles={customStyles}
                                  options={stateOptions}
                                  value={stateOptions?.find((option) => option?.value === watch()?.billstate) || ""}
                                  onChange={(selectedOption) => {
                                    clearErrors("billstate");
                                    handleShipAddressChangeState(selectedOption, "billstate", "shipstate");
                                  }}
                                />
                              );
                            }}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="billstate"
                            render={({ message }) => (
                              <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                            )}
                          />
                        </FlexContainer>
                        <FlexContainer {...customColFlexContainerProps} md="30%">
                          <LabelText style={{...customLabelStyle}}>
                            {(defaultCountry && defaultCountry.code === "US") ? zipCode : pincodeLabel} <span style={{ color: 'red' }}>*</span>
                          </LabelText>
                          <Controller
                            marginTop="8px !important"
                            marginBottom="0px"
                            defaultValue={""}
                            color={errors.zipCode ? "red" : "inherit"}
                            control={control}
                            name="zipCode"
                            isSearchable="true"
                            placeholder={(defaultCountry && defaultCountry.code === "US") ? zipCode : pincodeLabel}
                            rules={{
                              required: `${(defaultCountry && defaultCountry.code === "US") ? zipCode : pincodeLabel} is required`,
                              validate: isZipcodeValidate1
                            }}
                            render={({ field }) => (
                              <Input
                                {...field}
                                // style={{
                                //   marginTop: "0px",
                                //   marginBottom: "0px",
                                //   width: "299px",
                                //   borderRadius: "0px 0px 4px 4px",
                                // }}
                                defaultValue={watch()?.zipCode || ""}
                                type="text"
                                placeholder="Zip Code"
                                onChange={(e) => {
                                  clearErrors("zipCode");
                                  handleShipAddressChange(e.target.value, 'zipCode', 'shipzipCode');
                                }}
                                style={{...customInputStyle}}
                              />
                            )}
                            customInput={Input}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="zipCode"
                            render={({ message }) => (
                              <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                            )}
                          />
                        </FlexContainer>
                        <FlexContainer {...customColFlexContainerProps} md="30%">
                          <LabelText style={{...customLabelStyle}}>
                            Country <span style={{ color: 'red' }}>*</span>
                          </LabelText>
                          <Controller
                            color={errors.country ? "red" : "inherit"}
                            marginBottom="0px"
                            control={control}
                            name="country"
                            placeholder="Select a country"
                            rules={{
                              required: 'Shipping Country is required'
                            }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                className="px-0 border-0"
                                theme={(theme) => ({
                                  ...theme,
                                  borderRadius: '4px',
                                  boxShadow: 0,
                                })}
                                styles={customStyles}
                                options={countryOptions}
                                menuPlacement="auto"
                                value={countryOptions?.find((item) => item?.value === watch().country) || ""}
                                placeholder="Country"
                                onChange={(event) => {
                                  //getStatelistShip(event);
                                  //setCountryNameCode2(event.code);
                                  handleShipAddressChangeState(event, 'country', 'shipcountry')
                                  callBackCountryCode(event.value);
                                  getStatelist(event?.value);
                                  //setCountryNameCode(event.value);
                                }}
                                style={{...customInputStyle}}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="country"
                            render={({ message }) => (
                              <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                            )}
                          />
                        </FlexContainer>
                      </FlexContainer>
                    </FlexContainer>
                  </div>
                )}

                <Hr />
              </>
            }
          </>
        ) : (isZipCodeRequired && (!isBillingAdressRequired)) ? (
          <>
            <Hr/>
            <FlexContainer>
              <FlexContainer {...customRowFlexContainerProps}>
                <PH3Text className="my-3 mx-0 p-0" fontWeight="bold">BILLING DETAILS</PH3Text>
              </FlexContainer>
              <FlexContainer {...customRowFlexContainerProps}>
                <FlexContainer {...customColFlexContainerProps} md="47.5%">
                  <LabelText style={{...customLabelStyle}}>Country <span style={{ color: 'red' }}>*</span></LabelText>
                  <Controller
                    color={errors.country ? "red" : "inherit"}
                    marginBottom="0px"
                    control={control}
                    name="country"
                    placeholder="Select a country"
                    rules={{
                      required: 'Country is required'
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        className="px-0 border-0"
                        // theme={(theme) => ({
                        //   ...theme,
                        //   borderRadius: '4px',
                        //   boxShadow: 0,
                        // })}
                        styles={customStyles}
                        options={countryOptions}
                        menuPlacement="auto"
                        value={countryOptions?.find((item) => item?.value === watch().country) || ""}
                        placeholder="Country"
                        onChange={(event) => {
                          //getStatelistShip(event);
                          //setCountryNameCode2(event.code);
                          handleShipAddressChangeState(event, 'country', 'shipcountry')
                          callBackCountryCode(event.value);
                          getStatelist(event?.value);
                          //setCountryNameCode(event.value);
                        }}
                      />
                    )}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="country"
                    render={({ message }) => (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                    )}
                  />
                </FlexContainer>
                <FlexContainer {...customColFlexContainerProps} md="47.5%">
                  <LabelText>
                    {(defaultCountry && defaultCountry.code === "US") ? "Zip Code" : "Postal Code"} <span style={{ color: 'red' }}>*</span>
                  </LabelText>
                  <Controller
                    marginTop="8px !important"
                    marginBottom="0px"
                    defaultValue={""}
                    color={errors.zipCode ? "red" : "inherit"}
                    control={control}
                    name="zipCode"
                    isSearchable="true"
                    placeholder={(defaultCountry && defaultCountry.code === "US") ? zipCode : postalCode}
                    rules={{
                      required: `${(defaultCountry && defaultCountry.code === "US") ? zipCode : pincodeLabel} is required`,
                      validate: isZipcodeValidate
                    }}
                    as={<Input style={customInputStyle}
                      type="text"
                      name="zipCode"
                      onInput={event => {
                      if (!clearZipCode) {
                        getCountryCode(event.target.value);
                      }
                      }}
                      placeholder="Zip Code"
                    />}
                    customInput={Input}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="zipCode"
                    render={({ message }) => (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                    )}
                  />
                </FlexContainer>
              </FlexContainer>
            </FlexContainer>
          </>
        ) : ''
      }

      {
        isShippingAddressRequired ? (
          <>

            {
              <>

                {defaultCountry2 && (
                  <div>
                    <div className="mt-2">
                      {isBillingAdressRequired ? (
                        <label>
                          <Controller
                            marginBottom="0px" 
                            name='shppingAddress' 
                            control={control} 
                            as={
                                  <Input 
                                    type="checkbox"
                                    defaultChecked={checkedShipping}
                                    onClick={({ target }) => setBillingToShipping(target)}
                                    width="auto" 
                                  />
                                } 
                          />
                          <SpanText className="pl-2">Use Billing Address For Shipping </SpanText>
                        </label>
                      ) : ""}
                    </div>
                    <>
                      <FlexContainer>
                        <FlexContainer {...customRowFlexContainerProps}>
                          <PH3Text className="my-3 mx-0 p-0" fontWeight="bold">SHIPPING DETAILS</PH3Text>
                        </FlexContainer>
                        <FlexContainer {...customRowFlexContainerProps}>
                          <FlexContainer {...customColFlexContainerProps} md="100%">
                            <LabelText style={{...customLabelStyle}}>Address Line 1 <span style={{ color: 'red' }}>*</span></LabelText>
                            <Controller
                              defaultValue={''}
                              color={errors.shipaddress ? "red" : "inherit"}
                              marginBottom="0px"
                              control={control}
                              name='shipaddress'
                              placeholder="Address"
                              rules={{
                                required: 'Address is required',
                              }}
                              as={  
                                <Input
                                  style={{...customInputStyle}}
                                />
                                }
                              className={checkedShipping ? 'disabled' : ''}
                              disabled={checkedShipping}
                            />
                            <style jsx>{`
                                        .disabled {
                                          
                                          background-color: #f2f2f2;
                                          color: #888;
                                          cursor: not-allowed;
                                        }
                                      `}
                            </style>
                            <ErrorMessage
                              errors={errors}
                              name="shipaddress"
                              render={({ message }) => (
                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                              )}
                            />
                          </FlexContainer>
                        </FlexContainer>
                        <FlexContainer {...customRowFlexContainerProps}>
                          <FlexContainer {...customColFlexContainerProps} md="63.3%">
                            <LabelText style={{...customLabelStyle}}>Address Line 2</LabelText>
                            <Controller
                              defaultValue={""}
                              color={errors.shipaddress1 ? "red" : "inherit"}
                              marginBottom="0px"
                              control={control}
                              name="shipaddress1"
                              placeholder="Address"
                              as={
                                <Input
                                  style={{...customInputStyle}}
                                />
                              }
                              disabled={checkedShipping}
                              className={checkedShipping ? 'disabled' : ''}
                            />
                            <style jsx>{`
                                        .disabled {
                                          
                                          background-color: #f2f2f2;
                                          color: #888;
                                          cursor: not-allowed;
                                        }
                                      `}
                            </style>
                            <ErrorMessage
                              errors={errors}
                              name="shipaddress1"
                              render={({ message }) => (
                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                              )}
                            />
                          </FlexContainer>
                          <FlexContainer {...customColFlexContainerProps} md="31.6%">
                            <LabelText style={{...customLabelStyle}}>City <span style={{ color: 'red' }}>*</span></LabelText>
                              <Controller
                                defaultValue={""}
                                color={errors.shipcity ? "red" : "inherit"}
                                marginBottom="0px"
                                control={control}
                                name="shipcity"
                                placeholder="City"
                                rules={{
                                  required: 'City is required',
                                }}
                                as={
                                  <Input
                                    style={{...customInputStyle}}
                                  />
                                }
                                disabled={checkedShipping}
                                className={checkedShipping ? 'disabled' : ''}
                              />
                              <style jsx>{`
                              .disabled {
                                
                                background-color: #f2f2f2;
                                color: #888;
                                cursor: not-allowed;
                              }
                            `}
                            </style>
                            <ErrorMessage
                              errors={errors}
                              name="shipcity"
                              render={({ message }) => (
                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                              )}
                            />
                          </FlexContainer>
                        </FlexContainer>
                        <FlexContainer {...customRowFlexContainerProps}>
                          <FlexContainer {...customColFlexContainerProps} md="30%">
                            <LabelText style={{...customLabelStyle}}>State <span style={{ color: 'red' }}>*</span></LabelText>
                              <Controller
                                disabled={checkedShipping}
                                defaultValue={""}
                                color={errors.shipstate ? "red" : "inherit"}
                                marginBottom="0px"
                                marginTop="8px"
                                border="0px !important"
                                control={control}
                                name="shipstate"
                                placeholder="State"
                                rules={{
                                  required: 'Ship State is required'
                                }}

                                render={({ field }) => (
                                  <Select
                                    {...field}
                                    // theme={theme => ({
                                    //   ...theme,
                                    //   borderRadius: "4px",
                                    //   boxShadow: 0,
                                    // })}
                                    menuPlacement="auto"
                                    styles={customStyles}
                                    options={shipStateOptions}
                                    isDisabled={checkedShipping}
                                    value={stateOptions?.find((option) => option?.value === watch()?.shipstate) || ""}
                                    onChange={(option) => setValue('shipstate', option?.value)} // Properly pass the event handler
                                  />
                                )}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="shipstate"
                              render={({ message }) => (
                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                              )}
                            />
                          </FlexContainer>
                          <FlexContainer {...customColFlexContainerProps} md="30%">
                            <LabelText style={{...customLabelStyle}}>
                              {(defaultCountry && defaultCountry.code === "US") ? zipCode : postalCode} <span style={{ color: 'red' }}>*</span>
                              <Controller
                                marginTop="8px !important"
                                marginBottom="0px"
                                //defaultValue={defaultzipcode}
                                color={errors.shipzipCode ? "red" : "inherit"}
                                control={control}
                                name="shipzipCode"
                                isSearchable="true"
                                placeholder={(defaultCountry && defaultCountry.code === "US") ? zipCode : postalCode}
                                rules={{
                                  required: `${(defaultCountry && defaultCountry.code === "US") ? zipCode : pincodeLabel} is required`,
                                  validate: isZipcodeValidateShip
                                }}
                                as={<Input style={{
                                  marginTop: "0px",
                                  marginBottom: "0px",
                                  width: "299px",
                                  borderRadius: "0px 0px 4px 4px",
                                }}
                                  type="text"
                                  className={checkedShipping ? 'disabled' : ''}
                                  disabled={checkedShipping}
                                  // onInput={event => {
                                  // getCountryCode(event.target.value);
                                  //}}
                                  // className={checkedShipping ? 'disabled' : ''}
                                  onInput={
                                    (e) => handleShipAddressChangeStateShip(e.target.value, 'zipCode', 'shipzipCode')
                                  }
                                  placeholder="Zip Code"
                                />}
                                customInput={<Input style={customInputStyle}/>}
                              />
                              <style jsx>{`
                                .disabled {
                                  
                                  background-color: #f2f2f2;
                                  color: #888;
                                  cursor: not-allowed;
                                }
                              `}
                              </style>
                              <ErrorMessage
                                errors={errors}
                                name="shipzipCode"
                                render={({ message }) => (
                                  <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                )}
                              />
                            </LabelText>
                          </FlexContainer>
                          <FlexContainer {...customColFlexContainerProps} md="30%">
                            <LabelText style={customLabelStyle}>Country <span style={{ color: 'red' }}>*</span></LabelText>
                            <Controller
                              color={errors.shipcountry ? "red" : "inherit"}
                              marginBottom="0px"
                              control={control}
                              name="shipcountry"
                              placeholder="Select a country"
                              rules={{
                                required: 'Country is required'
                              }}
                              render={({ field }) => (
                                <Select
                                  isDisabled={checkedShipping}
                                  {...field}
                                  className="px-0 border-0"
                                  // theme={(theme) => ({
                                  //   ...theme,
                                  //   borderRadius: '4px',
                                  //   boxShadow: 0,
                                  // })}
                                  // getOptionLabel={(option) => option.name}
                                  // getOptionValue={(option) => option.code}
                                  styles={customStyles}
                                  options={countryOptions}
                                  value={countryOptions?.find((option) => option?.value === watch()?.shipcountry) || ""}
                                  placeholder="Country"
                                  onChange={(event) => {
                                    setValue('shipcountry', event?.value)
                                    setValue('shipstate', '')
                                    getStatelistShip(event?.value);
                                    setCountryNameCode2(event?.value);
                                    callBackCountryCode(event?.value);
                                  }}
                                />
                              )}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="shipcountry"
                              render={({ message }) => (
                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                              )}
                            />
                          </FlexContainer>
                        </FlexContainer>
                      </FlexContainer>
                    </>
                  </div>

                )}

                <Hr />
              </>
            }
          </>
        ) : "" 
      }
      {/* {
        showWhatsAppNotify && (
          <div className="mt-3">
            <label>
              <Controller
                marginBottom="0px" name='notify' control={control} as={<Input type="checkbox"
                  defaultChecked={checked}
                  onClick={({ target }) => setChecked(target.checked)} width="auto" />} />
              <SpanText className="pl-2">Notify on whatsapp</SpanText></label>
          </div>
        )
      } */}
      {
        showPromoter && (
          <div className="mt-3">
            <label>
              <Controller
                marginBottom="0px" name='promoter' control={control} as={<Input type="checkbox"
                  defaultChecked={promoterCheck}
                  onClick={({ target }) => setPromoterCheck(target.checked)} width="auto" />} />
              <SpanText className="pl-2">Get offers on money transfers to India with ICICI Bank Money2India</SpanText></label>
          </div>
        )
      }
    </>
  )
};

export default Card;
